import { Component } from '@angular/core';
import dataDocuments from '../../../assets/data/documents.json';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsersService } from '../../core/users/users.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/security/auth.service';
import { TermsAndHDResponde, UserLoggedResponse, UserLoginModel } from '../../models/user';
import { NgxSpinnerService } from "ngx-spinner";
import { Base } from '../common/base';
import { MatDialog } from '@angular/material/dialog';
import { DialogGenericFrame } from '../common/dialogs/dialog-generic-frame/dialog-generic-frame.component';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { environment as ENV } from '../../../environments/environment';
import { DialogOportunidadesComponent } from '../common/dialogs/dialog-oportunidades/dialog-oportunidades.component';
import { OportunidadComercialService } from '../../services/oportunidad-comercial/oportunidad-comercial.service';
import { DialogOporunidadesExternosComponent } from '../common/dialogs/dialog-oporunidades-externos/dialog-oporunidades-externos.component';
import { OportunidadesService } from '../../services/oportunidadesComercialesExternos/oportunidades.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent extends Base {
  public frmLogin: FormGroup;
  checkRemember: boolean = false;
  hidePassword: boolean = true;
  loginMessage: string = '';
  showTerms: boolean = false;
  termsText: SafeHtml = '';
  hdText: SafeHtml = '';
  userLoginData: UserLoginModel = new UserLoginModel();
  loggedUserData: UserLoggedResponse = new UserLoggedResponse();
  termsVersions: TermsAndHDResponde = new TermsAndHDResponde();
  ipAddress: string = '';
  showTyC: boolean = false;
  showHD: boolean = false;
  userData: any[] = [];
  documentTypeData: any[] = dataDocuments as Array<any>;
  logInfo: any;
  constructor(
    private _formBuilder: FormBuilder,
    private authService: AuthService,
    public userService: UsersService,
    private sanitizer: DomSanitizer,
    private spinner: NgxSpinnerService,
    private matDialog: MatDialog,
    public router: Router,
    private oportunidadService: OportunidadComercialService,
    private oportunidadExternoService: OportunidadesService
  ) {
    super();
    this.frmLogin = this._formBuilder.group({
      docType: ['', [Validators.required]],
      docNumber: ['', [Validators.required]],
      password: ['', [Validators.required]],
      checkRemember: [null, []],
    });

    this.authService.getPublicIp().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  private async remember() {}

  login() {
    this.spinner.show();
    this.loginMessage = '';
    this.userLoginData = {
      docType: this.frmLogin.value.docType,
      docNumber: this.frmLogin.value.docNumber,
      password: this.frmLogin.value.password,
    };

    this.authService.logIn(this.userLoginData).subscribe({
      next: (response) => {
        if (response.data.autenticado.estadoAutenticacion == 'EXITO') {
          this.loginMessage = '';
          this.loggedUserData = response.data.usuarioDTO;
          this.checkTerms();
        } else {
          this.spinner.hide();
          this.loginMessage =
            'Datos ingresados no válidos. Intente nuevamente.';
        }
      },
      error: (error) => {
        this.spinner.hide();
        if (error.status >= 500 && error.status <= 599) {
          this.loginMessage = 'Por favor comunicarse con el administrador.';
        } else {
          this.loginMessage =
            'Datos ingresados no válidos. Intente nuevamente.';
        }
      },
    });
  }

  checkTerms() {
    this.authService.checkTermsAndHD(this.userLoginData).subscribe({
      next: (response) => {
        this.termsVersions = response.data[0];
        if (
          this.termsVersions.VTYCVIGENTE != this.termsVersions.VTYCACEPTA ||
          this.termsVersions.VHDVIGENTE != this.termsVersions.VHDACEPTA
        ) {
          this.showTerms = true;
          if (this.termsVersions.VTYCVIGENTE != this.termsVersions.VTYCACEPTA) {
            this.showTyC = true;
          }
          if (this.termsVersions.VHDVIGENTE != this.termsVersions.VHDACEPTA) {
            this.showHD = true;
          }
          if (this.showTyC) this.loadTerms(1);
          else if (this.showHD) this.loadTerms(2);
        } else {
          this.spinner.hide();
          this.showTerms = false;
          this.finishLogin();
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.showDialog(
          'Error',
          'Ocurrió un problema al verificar los términos y condiciones.',
          'Aceptar',
          ''
        );
      },
    });
  }

  loadTerms(opt: number) {
    this.spinner.show();
    this.authService.loadTermsAndHD(opt).subscribe({
      next: (response) => {
        this.spinner.hide();
        if (opt == 1) {
          this.termsText = this.sanitizer.bypassSecurityTrustHtml(
            response.data[0].DESCRIPCION
          );
          if (this.showHD) this.loadTerms(2);
        } else if (opt == 2) {
          this.hdText = this.sanitizer.bypassSecurityTrustHtml(
            response.data[0].DESCRIPCION
          );
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.showDialog(
          'Error',
          'Ocurrió un problema al consultar los terminos y condiciones.',
          'Aceptar',
          ''
        );
      },
    });
  }

  acceptTyC() {
    this.spinner.show();
    this.authService.acceptTermsAndHD("aceptDocTyC", this.termsVersions.VTYCVIGENTE, this.userLoginData, this.loggedUserData,this.ipAddress).subscribe({
      next: response => {
        // this.spinner.hide();
        if(response.status){ //solo es true si el cod es 0 en el servicio de coomeva
            this.acceptHD();
        }else{
          this.showDialog("Error",response.message,"Aceptar","");
        }
      },
      error: error => {
        this.spinner.hide();
        this.showDialog("Error","Ocurrió un problema al aceptar los términos y condiciones TyC.","Aceptar","");
      }
    });
  }

  acceptHD(){
    this.authService.acceptTermsAndHD("aceptDocHD", this.termsVersions.VHDVIGENTE, this.userLoginData, this.loggedUserData,this.ipAddress).subscribe({
      next: response => {
        this.spinner.hide();
        if(response.status){ //solo es true si el cod es 0 en el servicio de coomeva
          this.finishLogin();
        }else{
          this.showDialog("Error",response.message,"Aceptar","");
        }
      },
      error: error => {
        this.spinner.hide();
        this.showDialog("Error","Ocurrió un problema al aceptar los términos y condiciones HD.","Aceptar","");
      }
    });
  }

  async finishLogin() {
    this.showTerms = false;
    this.loggedUserData.document =
      this.frmLogin.value.docType + '. ' + this.frmLogin.value.docNumber;

    // Guardar info usuario
    await this.authService.setAuthInfo(
      Object.assign(
        {},
        { document: this.frmLogin.value.docNumber },
        this.loggedUserData
      )
    );

    // Refrescar logInfo
    this.logInfo = await this.authService.getAuthInfo();

    const cedulaAsesor =
      this.loggedUserData.document?.split('. ')[1] ||
      this.loggedUserData.document;

    if (!cedulaAsesor) {
      this.spinner.hide();
      alert('No se encontró el documento del asesor');
      return;
    }

    const rolUsuario = this.logInfo?.roles?.[0]?.nombreRol || '';
    this.spinner.show();

    if (rolUsuario === 'Asesor Interno') {
      // ---------------------- Lógica Asesor Interno ----------------------
      const filtros = { identificacion: '', estado_oportunidad: '' };
      const request = {
        accountTipoDocumento: '',
        accountNumeroIdentificacion: filtros.identificacion || '',
        stageName: filtros.estado_oportunidad || '',
        ownerIdentificacin: cedulaAsesor,
      };

      this.oportunidadService.getOportunidadesFiltradas(request).subscribe({
        next: (response) => {
          const records = response?.data?.records || [];
          this.oportunidadService.mostrarMensajeModal().subscribe({
            next: (modalResp) => {
              this.spinner.hide();
              this.procesarModalYMostrar(
                records,
                modalResp,
                'StageName',
                DialogOportunidadesComponent
              );
            },
            error: () => {
              this.spinner.hide();
              alert('Error al obtener mensaje del modal');
            },
          });
        },
        error: () => {
          this.spinner.hide();
          alert('Error al obtener oportunidades');
        },
      });
    } else if (rolUsuario === 'Asesor Externo') {
      // ---------------------- Lógica Asesor Externo ----------------------
      const filtros = {
        id: null,
        tipoIdentificacion: '',
        numeroIdentificacion: '',
        estado: '',
        fechaInicio: '',
        fechaUltima: '',
        codigoAsesor: '',
      };

      this.oportunidadExternoService
        .obtenerCodigoAsesor(cedulaAsesor)
        .subscribe({
          next: (codigoAsesor: number | null) => {
            if (!codigoAsesor) {
              this.spinner.hide();
              alert('No se encontró código para el asesor');
              this.router.navigateByUrl('/main/portafolio');
              return;
            }

            const request = {
              id: filtros.id,
              tipoIdentificacion: filtros.tipoIdentificacion,
              numeroIdentificacion: filtros.numeroIdentificacion,
              estado: filtros.estado,
              fechaInicio: filtros.fechaInicio,
              fechaUltima: filtros.fechaUltima,
              codigoAsesor: codigoAsesor.toString(),
            };

            this.oportunidadExternoService.consultar(request).subscribe({
              next: (records) => {
                this.oportunidadExternoService.mostrarMensajeModal().subscribe({
                  next: (modalResp) => {
                    this.spinner.hide();
                    this.procesarModalYMostrar(
                      records,
                      modalResp,
                      'estado',
                      DialogOporunidadesExternosComponent
                    );
                  },
                  error: (err) => {
                    this.spinner.hide();
                    console.error('Error al obtener mensaje modal:', err);
                    alert('Error al obtener mensaje del modal');
                    this.router.navigateByUrl('/main/portafolio');
                  },
                });
              },
              error: (err) => {
                this.spinner.hide();
                console.error('Error al obtener oportunidades:', err);
                alert('Error al obtener oportunidades');
                this.router.navigateByUrl('/main/portafolio');
              },
            });
          },
          error: (err) => {
            this.spinner.hide();
            console.error('Error al obtener código del asesor:', err);
            alert('Error al obtener código del asesor');
            this.router.navigateByUrl('/main/portafolio');
          },
        });
    } else {
      this.spinner.hide();
      this.router.navigateByUrl('/main/portafolio'); // Nuevo
     // alert('Rol de usuario no reconocido');
    }
  }

  private procesarModalYMostrar(
    records: any[],
    modalResp: any,
    campoEstado: string,
    componenteModal: any
  ) {
    const templateHtml = modalResp?.data?.content?.template || '';

    const estadoRegex = /<div[^>]*>\s*([^–<]+)\s*–\s*XX\s*<\/div>/g;
    let estadosExtraidos: string[] = [];
    let match;
    while ((match = estadoRegex.exec(templateHtml)) !== null) {
      estadosExtraidos.push(match[1].trim().toUpperCase());
    }

    const conteo: Record<string, number> = {};
    estadosExtraidos.forEach((e) => (conteo[e] = 0));

    records.forEach((op: any) => {
      const estado = (op[campoEstado] || 'SIN ESTADO').toUpperCase();
      if (conteo.hasOwnProperty(estado)) {
        conteo[estado] += 1;
      }
    });

    this.matDialog
      .open(componenteModal, {
        width: '600px',
        data: {
          conteo,
          template: templateHtml,
        },
      })
      .afterClosed()
      .subscribe(() => {
        this.router.navigateByUrl('/main/portafolio');
      });
  }

  initForgetPassword() {
    this.matDialog.open(DialogGenericFrame, {
      width: '90%',
      data: {
        url: 'https://oficinavirtualmp.coomeva.com.co/profilemp-web/restclave.jspx',
      },
    });
  }

  get iconName(): string {
    return this.hidePassword ? 'eye' : 'eye_off';
  }

  resetForm(){
    this.frmLogin.reset();
    //window.location.reload();
  }

  showDialog(title: string, message: string, accept: string, cancel:string){
    this.showMessageDialog(title, message, accept, cancel, true, 2, this.matDialog, (_: any) => {
    });
  }
}
